module.exports = __webpack_public_path__ + "static/media/blend-platform.bc8c89f4.png";